module.exports = __webpack_public_path__ + "static/user-wall-f31a642a852d81e2a8ef00003332fabc.jpg";